import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import {
    centeredModalBoxSx,
    modalBackdropProps,
} from '../../utils/styles/modal.overlay';
import ModalCloseButton from '../UI/ModalCloseButton';

const modalPaperSx = centeredModalBoxSx({
    width: { xs: 'min(calc(100% - 32px), 420px)', sm: 550 },
    minHeight: { xs: 120, sm: 140 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 3,
});

export default function SupportModal(props) {
    const { setOpen, open } = props;

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="support-modal-title"
                aria-describedby="support-modal-description"
                BackdropProps={modalBackdropProps}
            >
                <Box sx={modalPaperSx}>
                    <ModalCloseButton onClick={() => setOpen(false)} />

                    <Typography
                        id="support-modal-title"
                        sx={{
                            textAlign: 'center',
                            fontFamily: '"Poppins", sans-serif',
                            fontWeight: 500,
                            fontSize: '1.0rem',
                            lineHeight: 1.5,
                            color: 'var(--primary-text-color)',
                            px: { xs: 2, sm: 3 },
                        }}
                    >
                        Contact{' '}
                        <a
                            href="mailto:support@oxiwear.com"
                            rel="noreferrer"
                            target="_blank"
                            style={{
                                color: 'var(--primary-text-theme-color)',
                                textDecorationLine: 'underline',
                            }}
                        >
                            support@oxiwear.com
                        </a>{' '}
                        if you have any issues.
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
}
